class ReviewsCarousel extends HTMLElement {
    connectedCallback() {
        if (this.reviewsCarousel) {
            return;
        }

        const reviewsCarouselEl = this.querySelector('.previewCartProductReviews');

        if (!reviewsCarouselEl || !reviewsCarouselEl.querySelectorAll('.glide__slides .product-review').length) {
            return;
        }

        reviewsCarouselEl.style.display = 'block';
        this.reviewsCarousel = new Glide(reviewsCarouselEl, {
            type: 'slider',
            perView: 1,
            rewind: true,
            bound: true,
            autoplay: 5000,
            hoverpause: true,
            peek: 24
        });

        this.reviewsCarousel.mount();
    }

    disconnectedCallback() {
        if (this.reviewsCarousel) {
            this.reviewsCarousel.destroy();
            this.reviewsCarousel = null;
        }
    }
}

customElements.get('reviews-carousel') || customElements.define('reviews-carousel', ReviewsCarousel);